// 平台交互相关兼容方法
import Vue from 'vue'

const UA = navigator.userAgent
const PARTNER_APP = 'com.renrenche.partner' // 合伙人app
const SALE_APP = 'com.renrenche.salesorder' // 销售app
const INSPECTOR_APP = 'com.renrenche.carpublish' // 评估app
const TOB_APP = 'com.renrenche.tobapp' // 商家版app
const WECHAT_WORK = 'wxwork'; // 企业微信
const FIX_PRICE = 'miniprogram';// 小程序(定价)

export const IS_PARTNER_APP = UA.indexOf(PARTNER_APP) > -1 // 合伙人app
export const IS_SALE_APP = UA.indexOf(SALE_APP) > -1 // 销售app
export const IS_INSPECTOR_APP = UA.indexOf(INSPECTOR_APP) > -1 // 评估app
export const IS_TOB_APP = UA.indexOf(TOB_APP) > -1 // 商家版app
export const IS_WECHAT_WORK = UA.indexOf(WECHAT_WORK) > -1; // 企业微信
export const IS_FIX_PRICE = UA.indexOf(FIX_PRICE) > -1 || window.__wxjs_environment === FIX_PRICE; // 小程序(定价)


// 获取JwtHeader数据
export function exitWebView () {
  if (IS_PARTNER_APP || IS_SALE_APP) {
    Vue.$rrcBridge.nativeBridge('exitWebView') // exitWebView 适用于 合伙人app、销售app的关闭webview
  } else if (IS_INSPECTOR_APP || IS_TOB_APP) {
    if (window.Flutter) {
      Vue.$rrcBridge.asyncNativeBridge('ExitWebView') // ExitWebView 适用于 评估app Flutter下的的关闭webview
    } else {
      Vue.$rrcBridge.nativeBridge('backToLastActivity') // backToLastActivity 适用于 评估app的关闭webview
    }
  } else {
    window.history.back()
  }
}

// 获取JwtHeader数据
export function syncGetJwtHeader () {
  let jwtHeader = Vue.$rrcBridge.nativeBridge('getJwtHeader')
  jwtHeader = jwtHeader && JSON.parse(jwtHeader)
  if ((IS_PARTNER_APP || IS_SALE_APP) && jwtHeader) {
    jwtHeader = {
      Authorization: jwtHeader.Authorization,
      'GATEWAY-LOGIN-TOKEN': jwtHeader['GATEWAY-LOGIN-TOKEN'],
      'GATEWAY-USER-AGENT': jwtHeader['GATEWAY-USER-AGENT'] || window.navigator.userAgent,
      jwtHeader
    }
  } else if (IS_INSPECTOR_APP && jwtHeader) {
    jwtHeader = {
      Authorization: jwtHeader.data.authorization,
      'GATEWAY-LOGIN-TOKEN': jwtHeader.data['gateway-login-token'],
      'GATEWAY-USER-AGENT': jwtHeader.data['gateway-user-agent'] || window.navigator.userAgent,
      jwtHeader: jwtHeader.data
    }
  }
  return jwtHeader
}

export function getJwtHeader () {
  if (window.Flutter) {
    return new Promise((resolve, reject) => {
      Vue.$rrcBridge.asyncNativeBridge('GetJWTHeader', (err, data) => {
        if (err) {
          return reject(err)
        }
        if (data) {
          let jwtHeader = data
          jwtHeader = {
            Authorization: jwtHeader.Authorization || jwtHeader.authorization,
            'GATEWAY-LOGIN-TOKEN': jwtHeader['GATEWAY-LOGIN-TOKEN'] || jwtHeader['gateway-login-token'],
            'GATEWAY-USER-AGENT': jwtHeader['GATEWAY-USER-AGENT'] || jwtHeader['gateway-user-agent'] || window.navigator.userAgent,
            jwtHeader
          }
          return resolve(jwtHeader)
        }
        return reject()
      })
    })
  } else {
    return syncGetJwtHeader()
  }
}

// 是否为三大平台 --- 评估app、合伙人app、销售app
export function isBusinessPlatform () {
  return IS_PARTNER_APP || IS_SALE_APP || IS_INSPECTOR_APP || IS_TOB_APP
}

// token过期 -- 适用于评估app、合伙人app、销售app
export function tokenExpired () {
  if (isBusinessPlatform()) {
    if (window.Flutter) {
      Vue.$rrcBridge.asyncNativeBridge('TokenExpired')
    } else {
      Vue.$rrcBridge.nativeBridge('tokenExpired')
    }
  }
}

//  获取flutter支持的方法 异步
export function asyncGetActions () {
  return new Promise((resolve, reject) => {
    Vue.$rrcBridge.asyncNativeBridge('GetActions', (error, data) => {
      if (error) {
        return reject(error)
      }
      if (data) {
        let actions = data
        if (actions) {
          actions = actions || []
        }
        return resolve(actions)
      }
      return reject()
    })
  })
}

// 获取支持的方法
export function getActions () {
  if (window.Flutter) {
    return asyncGetActions()
  } else {
    let actions = Vue.$rrcBridge.nativeBridge('getActions')
    try {
      actions = typeof actions === 'string' ? JSON.parse(actions) : actions
      if (actions) {
        actions = actions.data || []
      }
    } catch {
      actions = []
    } finally {
      actions = Object.prototype.toString.call(actions) === '[object Array]' ? actions : []
    }
    return actions
  }
}

function sendSms (content, callback) {
  return new Promise((resolve, reject) => {
    // 发短信功能
    Vue.$rrcBridge.asyncNativeBridge('Sms', { content: content }, (error, data) => {
      if (error) {
        return reject(error)
      }
      if (data) {
        callback && callback()
        return resolve()
      }
      return reject()
    })
  })
}

// 唤起系统 发短信界面
/**
 * @param {String} content 内容
 * @param {function} callback 回调函数
 * content参数格式如下:
 *    发短信：'sms:1234567?body=发短信' （iOS终端：'sms:1234567&body=发短信'）
 */
export function systemSendSms (content, callback) {
  // 判断是否为flutter， 如果为flutter则调用action，否则创建 a标签
  if (window.Flutter) {
    sendSms(content, callback)
  } else {
    // H5 利用 a 标签 唤起系统电话、短信、邮件等界面
    const a = document.createElement('a')
    a.setAttribute('href', content)
    document.body.appendChild(a)
    callback && callback()
    a.click()
    document.body.removeChild(a)
  }
}


// 调用原生图片查看器
// index：默认展示第几张图片(请勿index越界)
// imgList：图片list
//     {
//       'name':名称
//       'url': 图片url地址
//     }
export function openGalleryPhoto (index, imgList) {
  return new Promise((resolve, reject) => {
    Vue.$rrcBridge.asyncNativeBridge('OpenGalleryPhoto', { index, imgList }, (error) => {
      if (error) {
        return reject(error)
      }
      return resolve()
    })
  })
}

/**
 * 保存文件到本地
 * @param {*} data 保存的数据 uri格式，需去除前缀 data:application/pdf;base64, 这部分数据
 * @param {*} type 文件类型 pdf/jpg/...
 * @param {*} name 文件名
 * @returns
 */
export function downloadAttachments (data, type, name) {
  return new Promise((resolve, reject) => {
    Vue.$rrcBridge.asyncNativeBridge('DownLoadAttachments', { data, type, name }, (error) => {
      if (error) {
        return reject(error)
      }
      return resolve()
    })
  })
}

/**
 * 客户意向提交成功后，通知app更新页面
 * @param {*} work_order_id 评估工单id
 * @param {*} work_order_customer_intention 客户意向
 * @returns
 */
 export function stitchingWorkOrderList (work_order_id, work_order_customer_intention) {
  const data = {
    work_order_id,
    work_order_customer_intention
  }
  return new Promise((resolve, reject) => {
    Vue.$rrcBridge.asyncNativeBridge('stitchingWorkOrderList', data, (error) => {
      if (error) {
        return reject(error)
      }
      return resolve()
    })
  })
}


/**
 * 跟进任务列表拨打用户手机号
 * @param {*} work_order_id 评估工单id
 * @param {*} work_order_customer_intention 客户意向
 * @returns
 */
 export function callOwnersPhone (rrcId, carId) {
  const data = {
    rrcId,
    carId
  }
  return new Promise((resolve, reject) => {
    Vue.$rrcBridge.asyncNativeBridge('callOwnersPhone', data, (error) => {
      if (error) {
        return reject(error)
      }
      return resolve()
    })
  })
}
